// Packing Report "Completed" checkbox: ticking or unticking one juice's row
// saves immediately (no page reload), the same fetch-and-patch-the-DOM
// approach as wholesale_price_editor.js. Only exists on a freshly-rendered
// Packing Report, so it's wired up on "turbolinks:load".

function csrfToken() {
  var meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : ''
}

function toggleCompletion(checkbox) {
  var row = checkbox.closest('.js-packing-row')
  var byLabel = checkbox.closest('.reports-completed-check').querySelector('.reports-completed-by')
  var completed = checkbox.checked

  checkbox.disabled = true

  fetch('/admin/reports/packing_completions/toggle', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-CSRF-Token': csrfToken(),
      Accept: 'application/json'
    },
    body: [
      'completed=' + encodeURIComponent(completed),
      'completion[juice_id]=' + encodeURIComponent(checkbox.dataset.juiceId),
      'completion[from_date]=' + encodeURIComponent(checkbox.dataset.fromDate),
      'completion[to_date]=' + encodeURIComponent(checkbox.dataset.toDate),
      'completion[date_field]=' + encodeURIComponent(checkbox.dataset.dateField)
    ].join('&')
  })
    .then(function (response) { return response.json() })
    .then(function (data) {
      row.classList.toggle('is-completed', data.completed)
      byLabel.textContent = data.completed ? data.completed_by + ' • ' + data.completed_at : ''

      // "Bottles to Pack" is what's left to do, so a completed row comes
      // back out of it (and goes back in if unchecked).
      var remainingEl = document.getElementById('packing-bottles-remaining')
      var quantity = parseInt(checkbox.dataset.quantity, 10) || 0
      if (remainingEl) remainingEl.textContent = parseInt(remainingEl.textContent, 10) + (data.completed ? -quantity : quantity)
    })
    .catch(function () {
      // Network hiccup: put the checkbox back the way it was rather than
      // leaving it showing a state that wasn't actually saved.
      checkbox.checked = !completed
    })
    .then(function () {
      checkbox.disabled = false
    })
}

document.addEventListener('turbolinks:load', function () {
  document.querySelectorAll('.js-packing-completed-checkbox').forEach(function (checkbox) {
    checkbox.addEventListener('change', function () { toggleCompletion(checkbox) })
  })
})
